<template>
<div>
    LICENCES
</div>
</template>
<script>
import { Component, Prop, Vue } from "vue-property-decorator";

export default {
    data() {
        return {
        };
    },
    created(){
    },
    methods: {
    }
}
</script>
<style scoped lang="scss">
@import "./public/assets/scss/components/_usuarioam.scss";
</style>
